import { useState } from "react";
import { useDispatch } from "react-redux";
import * as actions from "../../../Redux/Actions";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../component/Toasts/Toasts";
import "../../SuccessionPlanning/readable-form.scss";

const AddOrEditKra = (props: any) => {
  const { editData, setShowModal, setEditData, handleApiCall } = props;
  const dispatch = useDispatch();

  const [form, setForm] = useState<any>({
    title: editData?.title ?? "",
    description: editData?.description ?? "",
  });
  const [errors, setErrors] = useState<any>({ title: "" });
  const [btnDisable, setBtnDisable] = useState(false);

  const validate = () => {
    if (!form.title.trim()) {
      setErrors({ title: "KRA name cannot be empty" });
      return false;
    }
    setErrors({ title: "" });
    return true;
  };

  const done = (res: any, successMsg: string) => {
    setBtnDisable(false);
    if (res?.error) {
      const msg =
        res?.error?.response?.data?.error?.error_description ||
        "Something went wrong";
      showErrorToastMessage(msg);
    } else if (res?.data) {
      showSuccessToastMessage(successMsg);
      setShowModal(false);
      setEditData("");
      handleApiCall();
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!validate()) return;
    setBtnDisable(true);
    const payload = {
      title: form.title.trim(),
      description: form.description?.trim(),
    };
    if (editData) {
      dispatch(
        actions.updateKraAction(editData._id, payload, (res: any) =>
          done(res, "KRA updated successfully")
        )
      );
    } else {
      dispatch(
        actions.createKraAction(payload, (res: any) =>
          done(res, "KRA added successfully")
        )
      );
    }
  };

  return (
    <div className="readable-form">
      <div>
        <label className="form-label">
          KRA Name<span className="required">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="e.g. Alert Monitoring & Triage"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
        />
        {errors.title !== "" && <p className="error">{errors.title}</p>}
      </div>

      <div className="mt-3">
        <label className="form-label">Description</label>
        <textarea
          className="form-control"
          rows={3}
          placeholder="What this KRA measures (optional)"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
        />
      </div>

      <div className="modal-btn-wrapper mt-4 mb-4">
        <div>
          <button
            className="btn cancel-btn buttonsize"
            onClick={() => {
              setEditData("");
              setShowModal(false);
            }}
          >
            Cancel
          </button>
        </div>
        <div>
          <button
            className="btn add-submit-button buttonsize"
            disabled={btnDisable}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOrEditKra;
